
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { PortionData } from '@/types';
import { getImage } from '@/utils/imageManager';

@Component({})
export default class PortionSelector extends Vue {
	@Prop() portions!: PortionData[];

	mounted() {
		const self: HTMLInputElement = <HTMLInputElement>this.$refs.self;
		self.focus();
	}

	@Emit()
	private unfocus(): void {}

	@Emit()
	private select(index: number): number {
		return index;
	}

	private getImageUrl(imageUrl: string): string {
		return getImage(imageUrl);
	}
}
